<template>
  <div>
    <div class="NEW-HEADER">
      <div class="bg-black">
        <div class="container p-x-1:mo">
          <div class="d-flex">
            <div @click="hamburgerClick()" >
              <div :class="{'NEW-WHATS-NEW': showWhatsNew && $device.isMobile}"></div>
              <vk-icon
                  name="hamburger"
                  size="30"
                  class="d-none:t HAMBURGER"
              />
            </div>
            <router-link :to="{ name: homelink }" class="m-y-1">
              <header-logo :dark="light"/>
            </router-link>
            <div class="d-flex fd-column w-100">
              <div class="d-flex ai-center m-l-auto m-b-1 NEW-HEADER-DESKTOP">
                <div
                    v-for="(link, mIndex) in $options.LINKS.main"
                    :key="mIndex"
                    class="d-none:mo m-x-1 h-100">
                  <router-link
                      v-if="link.isRoute"
                      :to="{
                        name: link.name,
                        params: {
                          jobsStatusAlias: $options.JOBS_STATUS_ALIASES.new.key,
                          activePerformanceTab: $options.PERFORMANCE_TAB_NAMES.summary.key,
                          activeNotificationTab: $options.NOTIFICATION_TAB_NAMES.updates.key,
                        },
                      }"
                      class="x-header-link text-capitalize p-x-0 h-100 m-t-1 router-link-inactive"
                      :class="{'router-active-link': $route.name === link.name}"
                      :selenium="`header-${link.label}-link`">
                    <vk-icon
                        :name="link.icon"
                        class="m-r-1"
                        :size="link.size? link.size:15"
                        :class="{
                          'WHATS-NEW': showWhatsNew && link.name === 'dashboard::pro::notifications'
                    }"/>
                    {{link.label}}
                  </router-link>
                  <div
                      v-else
                      class="x-header-link text-capitalize p-x-0 h-100 m-t-1 router-link-inactive"
                      @click="nonRouteClick(link)">
                    <vk-icon
                        :name="link.icon"
                        class="m-r-1"
                        :size="link.size? link.size:15" />
                    <span class="m-r-1"> {{link.label}} </span>
                  </div>
                </div>
              </div>
              <div class="d-flex ai-center m-l-auto m-r-auto NEW-HEADER-DESKTOP">
                <div
                    v-for="(link, mIndex) in $options.LINKS.sub"
                    :key="mIndex"
                    class="d-none:mo m-x-4:d m-x-2 h-100">
                  <router-link
                      v-if="link.isRoute"
                      :to="{
                        name: link.name,
                        params: {
                          jobsStatusAlias: $options.JOBS_STATUS_ALIASES.new.key,
                          activePerformanceTab: $options.PERFORMANCE_TAB_NAMES.summary.key,
                          activeNotificationTab: $options.NOTIFICATION_TAB_NAMES.updates.key,
                        },
                      }"
                      class="x-header-link text-capitalize p-x-0 h-100 router-link-inactive"
                      :class="{
                        'router-active-link-sub': $route.name === link.name,
                        'NEW-MESSAGES': unreadMessages && link.name === 'dashboard::pro::messages'
                      }"
                      :selenium="`header-${link.label}-link`">
                    {{link.label}}
                  </router-link>
                  <div
                      v-else
                      class="x-header-link text-capitalize p-x-0 h-100 router-link-inactive"
                      @click="nonRouteClick(link)">
                    <span class="m-r-1"> {{link.label}} </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-none:t">
        <mobile-nav-header
            @on-none-route-menu="nonRouteClick"
            :isOpen="isOpen"
            @close="hamburgerClick"/>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { isBefore } from 'date-fns';
import LINKS from '@/layouts/components/newAppHeaderPro/links-constant';
import Storage from '@homeservices/tool-kit/storage/local-storage';
import HeaderLogo from '@/layouts/components/HeaderLogo';
import HeaderNotifications from '@/layouts/components/newAppHeaderPro/HeaderNotifications';
import HeaderMenu from '@/layouts/components/HeaderMenu';
import MobileNavHeader from '@/layouts/components/newAppHeaderPro/MobileNavHeader';
import HeaderMenuChevron from '@/layouts/components/HeaderMenuChevron';
import jobParams from '@/mixins/job-params';
import { PERFORMANCE_TAB_NAMES } from '@/constants/performance-tab-names';
import { NOTIFICATION_TAB_NAMES } from '@/constants/notification-tab-names';

const UPDATES_LAST_SEEN_TIME = 'TIME_LAST_SEEN';
const PRO_XTRA_URL = 'https://www.homedepot.com/myaccount/dashboard';
export default {
  LINKS,
  PERFORMANCE_TAB_NAMES,
  NOTIFICATION_TAB_NAMES,
  PRO_XTRA_URL,
  name: 'app-header-pro',
  components: {
    HeaderLogo,
    HeaderNotifications,
    HeaderMenu,
    HeaderMenuChevron,
    MobileNavHeader,
  },
  mixins: [
    jobParams,
  ],
  props: {
    light: {
      type: Boolean,
      default: false,
    },
  },
  provide () {
    return {
      $menu: this.$data,
    };
  },
  data () {
    return {
      PRO_XTRA_URL,
      isOpen: false,
      dateOfLastUpate: null,
      messageInterval: 240000,
      checkForMessages: null,
      updatesInterval: 1800000,
      checkForUpdates: null,
    };
  },
  computed: {
    ...mapGetters('prohub/whatsNew', ['groupedWhatsNewItems', 'timeUpdateSeen']),
    ...mapGetters('account/pro/inbox', ['hasUnreadMessages']),
    homelink () {
      return this.$store.getters['user/isPro'] ? 'dashboard' : 'homepage';
    },
    currentSubRouteName () {
      return this.$route.name;
    },
    showWhatsNew () {
      if (this.timeUpdateSeen) {
        return isBefore(new Date(this.timeUpdateSeen), new Date(this.dateOfLastUpate));
      }
      return true;
    },
    unreadMessages () {
      return this.hasUnreadMessages;
    },
  },
  watch: {
    groupedWhatsNewItems (val) {
      this.dateOfLastUpate = val.latest[0].date;
    },
  },
  mounted () {
    this.checkForWhatsNewUpdates();
    this.checkForUpdates = setInterval(() => {
      this.checkForWhatsNewUpdates();
    }, this.updatesInterval);
    this.fetchMessages();
    this.checkForMessages = setInterval(() => {
      this.fetchMessages();
    }, this.messageInterval);
    this.updatePendo();
  },
  beforeDestroy () {
    clearInterval(this.checkForUpdates);
    clearInterval(this.checkForMessages);
  },
  methods: {
    ...mapActions('account/pro/inbox', ['fetchInbox']),
    ...mapActions('account/pro', ['updatePendo']),
    nonRouteClick (route) {
      if (route.label === 'Help Center') {
        window.open(`${this.$runtimeConstants.SALESFORCE_HELP_CENTER}?login=true`, '_blank');
      }
      if (route.label === 'Access Pro Xtra') {
        this.proXtraClick();
        window.open(this.PRO_XTRA_URL, '_blank');
      }
      if (route.label === 'Sign Out') {
        this.$store.dispatch('user/logout');
      }
    },
    hamburgerClick () {
      this.isOpen = !this.isOpen;
    },
    async checkForWhatsNewUpdates () {
      await this.$store.dispatch('prohub/whatsNew/fetchWhatsNewList');
      this.$store.commit('prohub/whatsNew/setTimeUpdateSeen', Storage.get(UPDATES_LAST_SEEN_TIME).time);
    },
    proXtraClick () {
      this.$events.$emit(this.$events.B2B_URL_CLICK, { tab: this.$route.name });
    },
    async fetchMessages () {
      try {
        this.fetchInbox({ reason: 'unread' });
      } catch (e) {
        console.error(e); // eslint-disable-line no-console
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@homeservices/design-kit/tools";
@keyframes wiggle {
  0%   { transform: translateY(0px) rotate(0deg); }
  80%  { transform: translateY(0px) rotate(0deg); }
  82%  { transform: translateY(-10px) rotate(-5deg); }
  85%  { transform: translateY(-10px) rotate(5deg); }
  87%  { transform: translateY(-10px) rotate(-5deg); }
  90%  { transform: translateY(-10px) rotate(5deg); }
  100% { transform: translateY(0px) rotate(0deg); }
}
.NEW-HEADER {
    box-shadow: 0 8px 6px -6px rgba(black, 0.30);
}
.NEW-HEADER-DESKTOP {
  font-size:12px;
    .router-link-inactive {
        border-bottom: 5px solid black;
    }
    .router-active-link {
        background-color: #000 !important;
        color: $color-depot;
    }
    .router-active-link-sub {
        background-color: #000 !important;
        color: $color-depot;
        border-bottom: 5px solid $color-depot;
    }
}
.NEW-PILL {
  position:relative;
  margin-top: -12px;
  background-color: $color-depot !important;
  color: white !important;
  align-self: end;
  padding: 0px 4px;
  border-radius: 90px;
  font-size: 8px;
}
.WHATS-NEW {
  position: relative;
  animation: wiggle 3.0s infinite;
}
.NEW-WHATS-NEW{
  content: '';
  position:absolute;
  top: 10px;
  left: 35px;
  @include circle (8px);
  background-color: red;
}
.NEW-MESSAGES::after{
  content: '';
  position: relative;
  top: -6px;
  @include circle (8px);
  background-color: red;
}
.PROXTRA {
  margin-top: -1px;
}
.HAMBURGER {
  padding: 7px 10px 5px 0px;
  color: white;
}

</style>
